'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryLineStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var barProgress = (0, _styledComponents.keyframes)(['0%{transform:scaleX(1) translateX(-100%);}50%{transform:scaleX(1) translateX(0%);}75%{transform:scaleX(1) translateX(0%);animation-timing-function:cubic-bezier(.28,.62,.37,.91);}100%{transform:scaleX(0) translateX(0%);}']);

var indeterminate = function indeterminate(_ref) {
  var indeterminate = _ref.indeterminate;
  return indeterminate ? (0, _styledComponents.css)(['background-color:transparent !important;width:100%;transform-origin:right center;animation:', ' 2s linear infinite;'], barProgress) : '';
};

var style = function style(_ref2) {
  var themeFromProvider = _ref2.theme;

  var componentTheme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider).reactackle.components.progress;

  return (0, _styledComponents.css)(['height:', ';'], (0, _reactackleCore.getValueString)(componentTheme.linear.thickness));
};

var PrimaryLineStyled = exports.PrimaryLineStyled = _styledComponents2.default.div.withConfig({
  displayName: 'PrimaryLineStyled'
})(['position:absolute;top:0;left:0;width:100%;transform:scaleX(0);transform-origin:left center;will-change:transform;', ' ', ' ', ''], style, indeterminate, (0, _reactackleCore.transition)('transform, background-color', '800ms'));

PrimaryLineStyled.displayName = 'PrimaryLineStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-progress/dist/LinearProgress/styles/PrimaryLineStyled.js
// module id = 765
// module chunks = 0